import { render } from "./ModuleAssessmentsChart.vue?vue&type=template&id=4a79da72"
import script from "./ModuleAssessmentsChart.vue?vue&type=script&lang=js"
export * from "./ModuleAssessmentsChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__